import React from 'react';
import { Line } from 'react-chartjs-2';
import dayjs from 'dayjs';
import './chartSetup.ts';
import { SEMANTIC } from '../../theme/statusColors.ts';

interface QuoteMonthPoint {
  month: string; // 'YYYY-MM'
  sent: number;
  accepted: number;
}

interface QuotesTrendChartProps {
  data: QuoteMonthPoint[];
}

// Andamento preventivi: emessi vs accettati/convertiti per mese
const QuotesTrendChart: React.FC<QuotesTrendChartProps> = ({ data }) => {
  const labels = data.map(p => dayjs(p.month, 'YYYY-MM').format('MM/YYYY'));

  const chartData = {
    labels,
    datasets: [
      {
        label: 'Emessi',
        data: data.map(p => p.sent),
        borderColor: SEMANTIC.info,
        backgroundColor: `${SEMANTIC.info}33`,
        tension: 0.3,
        pointRadius: 3,
        fill: true,
      },
      {
        label: 'Accettati',
        data: data.map(p => p.accepted),
        borderColor: SEMANTIC.success,
        backgroundColor: `${SEMANTIC.success}33`,
        tension: 0.3,
        pointRadius: 3,
        fill: true,
      },
    ],
  };

  const options: any = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: { mode: 'index' as const, intersect: false },
    plugins: {
      legend: { position: 'bottom' as const, labels: { boxWidth: 12, font: { size: 11 } } },
    },
    scales: {
      y: { beginAtZero: true, ticks: { font: { size: 11 }, precision: 0 } },
      x: { ticks: { font: { size: 11 } } },
    },
  };

  return (
    <div style={{ height: 280 }}>
      <Line data={chartData} options={options} />
    </div>
  );
};

export default QuotesTrendChart;
